//#region src/menu_section_header_type.ts
var MenuSectionHeaderType = /* @__PURE__ */ function(MenuSectionHeaderType) {
	MenuSectionHeaderType["Text"] = "text";
	MenuSectionHeaderType["Image"] = "image";
	MenuSectionHeaderType["ImageAndText"] = "image-and-text";
	MenuSectionHeaderType["ImageAndTextHorizontal"] = "image-and-text-horizontal";
	return MenuSectionHeaderType;
}(MenuSectionHeaderType || {});
//#endregion
export { MenuSectionHeaderType };

//# sourceMappingURL=menu_section_header_type.js.map